/**
 * Adds separators to a phone number if we know how to. Non-10/11 digit numbers are returned as-is.
 * Null/undefined friendly.
 */
export const prettyPhone = (phoneNumber: string | number | undefined | null): string => {
  if (!phoneNumber) {
    return '';
  }

  const phone = phoneNumber.toString();

  if (!parseInt(phone, 10)) {
    return phone;
  }

  if (phone.length === 10) {
    const firstThree  = phone.substr(0, 3);
    const secondThree = phone.substr(3, 3);
    const lastFour    = phone.substr(6, 4);

    return firstThree + '-' + secondThree + '-' + lastFour;
  }

  if (phone.length === 11) {
    const countryCode = phone.substr(0, 1);
    const firstThree  = phone.substr(1, 3);
    const secondThree = phone.substr(4, 3);
    const lastFour    = phone.substr(7, 4);

    return countryCode + '-' + firstThree + '-' + secondThree + '-' + lastFour;
  }

  return phone;
};
